export default {
  allStates: 'Wszystkie stany',
  zeroStates: 'Wybrano 0 stanów',
};
